import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function EmailLogs() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/logs?limit=500").then((r) => setLogs(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="logs-page">
      <div>
        <div className="overline">Activity</div>
        <h1 className="font-display text-4xl mt-2 text-[#0F172A]">Email Logs</h1>
        <p className="text-[#64748B] mt-2 text-sm">Every email sent or attempted by your campaigns.</p>
      </div>

      <div className="bg-white border border-[#E2E8F0] rounded-2xl card-soft overflow-hidden" data-testid="logs-table">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>When</TableHead>
              <TableHead>Recipient</TableHead>
              <TableHead>Subject</TableHead>
              <TableHead>Package</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="text-center py-12 text-[#64748B]">No emails yet.</TableCell>
              </TableRow>
            ) : (
              logs.map((l) => (
                <TableRow key={l.id} data-testid={`log-row-${l.id}`}>
                  <TableCell className="text-xs text-[#64748B]">{new Date(l.sent_at).toLocaleString()}</TableCell>
                  <TableCell>
                    <div className="font-medium">{l.traveler_name}</div>
                    <div className="text-xs text-[#64748B]">{l.traveler_email}</div>
                  </TableCell>
                  <TableCell>{l.subject}</TableCell>
                  <TableCell>{l.package_title}</TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2">
                      <span className={`text-xs px-2.5 py-1 rounded-full ${
                        l.status === "sent" ? "bg-[#16A34A]/10 text-[#16A34A]" : "bg-[#DC2626]/10 text-[#DC2626]"
                      }`}>{l.status}</span>
                      {l.mocked && <span className="text-[10px] uppercase tracking-widest text-[#F59E0B]">Mocked</span>}
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
